import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePopup } from '../../contexts/PopupContext';
import { BottomNavSvgIcon } from './BottomNavigationIcons';
import './BottomNavigation.css';

function BottomNavigation({
  activeTab,
  setActiveTab,
  notificationCount = 0,
  accountRestricted = false,
  onLogout,
}) {
  const { t } = useTranslation('shared');
  const { openPopup } = usePopup();

  const tabs = [
    { id: 'discover', label: t('navigation.discover'), icon: 'discover' },
    { id: 'events', label: t('navigation.events'), icon: 'events' },
    { id: 'notifications', label: t('navigation.notifications'), icon: 'notifications', badge: notificationCount },
    { id: 'profile', label: t('navigation.profile'), icon: 'profile' },
  ];

  const handleCreateEvent = () => {
    openPopup('create-event', {}, 0);
  };

  const handleSettingsNav = () => {
    openPopup('settings', { onLogout: onLogout ?? undefined }, 0);
  };

  if (accountRestricted) {
    return (
      <nav className="bottom-navigation bottom-navigation--restricted" aria-label={t('navigation.mainNavAria')}>
        <button
          type="button"
          className="nav-item nav-item--settings-only active"
          onClick={handleSettingsNav}
          aria-label={t('navigation.settings')}
        >
          <span className="nav-icon-wrapper">
            <span className="nav-icon" aria-hidden="true">
              <BottomNavSvgIcon name="settings" size={22} />
            </span>
          </span>
          <span className="nav-label">{t('navigation.settings')}</span>
        </button>
      </nav>
    );
  }

  return (
    <nav className="bottom-navigation" aria-label={t('navigation.mainNavAria')}>
      {tabs.slice(0, 2).map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
          aria-current={activeTab === tab.id ? 'page' : undefined}
        >
          <span className="nav-icon-wrapper">
            <span className="nav-icon" aria-hidden="true">
              <BottomNavSvgIcon name={tab.icon} size={22} />
            </span>
            {tab.badge !== undefined && tab.badge > 0 && (
              <span className="nav-badge">{tab.badge > 99 ? '99+' : tab.badge}</span>
            )}
          </span>
          <span className="nav-label">{tab.label}</span>
        </button>
      ))}

      <button
        type="button"
        className="nav-create-btn"
        onClick={handleCreateEvent}
        aria-label={t('navigation.createEvent', 'Create Event')}
        title={t('navigation.createEvent', 'Create Event')}
      >
        <span className="nav-create-glow" aria-hidden="true" />
        <span className="nav-create-icon" aria-hidden="true">
          <BottomNavSvgIcon name="create" size={26} className="bottom-nav-icon-svg bottom-nav-icon-svg--create" />
        </span>
      </button>

      {tabs.slice(2).map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
          aria-current={activeTab === tab.id ? 'page' : undefined}
        >
          <span className="nav-icon-wrapper">
            <span className="nav-icon" aria-hidden="true">
              <BottomNavSvgIcon name={tab.icon} size={22} />
            </span>
            {tab.badge !== undefined && tab.badge > 0 && (
              <span className="nav-badge">{tab.badge > 99 ? '99+' : tab.badge}</span>
            )}
          </span>
          <span className="nav-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default BottomNavigation;
